import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';

export const StyledTheaterContent = styled('div')`
	width: 100%;
	height: 100%;
	position: relative;
	overflow: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'auto' : 'hidden'};
	-webkit-overflow-scrolling: touch;
	cursor: ${(props: { isZoomEnabled: boolean; isDragging: boolean }) => {
		if (!props.isZoomEnabled) {
			return 'default';
		}
		return props.isDragging ? 'grabbing' : 'grab';
	}};
	user-select: none;
	touch-action: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'none' : 'auto'};
`;

export const SvgIcon = styled('svg')`
	width: 100%;
	height: 100%;
	fill: ${StyleColor.White};
`;

export const Image = styled('img')`
	position: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'relative' : 'absolute'};
	left: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? '0' : '50%'};
	top: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? '0' : '50%'};
	transform: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'none' : 'translate(-50%,-50%)'};
	max-width: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'none' : '100%'};
	max-height: ${(props: { isZoomEnabled: boolean }) => props.isZoomEnabled ? 'none' : '100%'};
	display: block;
	user-select: none;
	-webkit-user-drag: none;
	pointer-events: none;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Content/styles.ts